import { Component, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
  AbstractControl,
} from "@angular/forms";
import { InventoryService } from "src/app/service/inventory.service";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { NgClass } from "@angular/common";
import { CrmService } from "src/app/service/crm.service";
import { ForwardReqComponent } from "../shared/forward-req/forward-req.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NoDataComponent } from "../shared/no-data/no-data.component";
import {
  alertModalDecline,
  alertModalDelete,
  alertModalWithoutConfirm,
} from "../../helpers/alert";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { ActivatedRoute } from "@angular/router";
import { environment } from "src/environments/environment";
interface Urgency {
  value: string;
  viewValue: string;
}

interface Request {
  value: string;
  viewValue: string;
}
interface newRequest {
  value: string;
  viewValue: string;
}
interface PendingServicesReq {
  value: string;
  viewValue: string;
}
interface ApprovedServicesReq {
  value: string;
  viewValue: string;
}

interface DeclinedInventorysReq {
  value: string;
  viewValue: string;
}

import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { INVENTORY_APPROVER_DEPARTMENTS, isHrOrItAdminDept } from 'src/app/constants/departments';
@Component({
    selector: "app-new-inventory",
    imports: [
        MatInputModule,
        InfiniteScrollModule,
        MatSelectModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        FormsModule,
        NgClass,
        ForwardReqComponent,
        NoDataComponent,
    ],
    templateUrl: "./new-inventory.component.html",
    styleUrls: ["./new-inventory.component.css", "../styles/inventory.css"]
})
export class NewInventoryComponent {
  /** HR, HR-HEAD, or IT-ADMIN: the same buttons and approver lists. */
  get isHrUser(): boolean {
    return isHrOrItAdminDept(this.userDepartment);
  }
  @ViewChild(ForwardReqComponent) forwardReqComponentRef!: ForwardReqComponent;

  newInventoryForm: FormGroup;
  forwardRequestForm: FormGroup;
  users: { value: string; viewValue: string; id: string }[] = [];

  urgencies: Urgency[] = [
    { value: "High", viewValue: "High" },
    { value: "Medium", viewValue: "Medium" },
    { value: "Low", viewValue: "Low" },
  ];

  selectedFilter: string = "";
  requests: Request[] = [
    { value: "New Inventory Request", viewValue: "Forwarded Request" },
  ];

  newReq: newRequest[] = [
    { value: "New Inventory Request", viewValue: "New Inventory Request" },
  ];

  pendingServiceReq: PendingServicesReq[] = [
    { value: "New Inventory Request", viewValue: "Pending Request" },
  ];
  approvedServiceReq: ApprovedServicesReq[] = [
    { value: "New Inventory Request", viewValue: "Approved Request" },
  ];

  declinedInventoryReq: DeclinedInventorysReq[] = [
    { value: "Rejected", viewValue: "Declined Request" },
  ];

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private inventoryService: InventoryService,
    private crmService: CrmService,
    private snackBar: MatSnackBar
  ) {
    this.newInventoryForm = this.fb.group({
      assetCategory: [
        "",
        [
          Validators.required,
          Validators.maxLength(50),
          this.noWhitespaceValidator,
        ],
      ],
      projectName: [
        "",
        [
          Validators.required,
          Validators.maxLength(100),
          this.noWhitespaceValidator,
        ],
      ],
      startDate: ["", Validators.required],
      endDate: ["", Validators.required],

      link1: [""],
      link2: [""],
      link3: [""],
      urgency: ["", Validators.required],
      approverName: [""],
      maximumCost: [
    "0",
    this.showForwardButton
      ? [Validators.required, this.noWhitespaceValidator]
      : []
  ],
  comment: [
    "",
    this.showForwardButton
      ? [Validators.required, this.noWhitespaceValidator]
      : []
  ],
    });

    // this.forwardRequestForm = this.fb.group({
    //   maximumCost: ['', Validators.required],
    //   comment: ['', Validators.required],
    //   link1: ['', Validators.required],
    //   link2: ['', Validators.required],
    //   link3: ['', Validators.required],
    //   selectedAdmin: ['', Validators.required]
    // })
  }

  noWhitespaceValidator(
    control: AbstractControl
  ): { [key: string]: any } | null {
    const isWhitespace = (control.value || "").trim().length === 0;
    return !isWhitespace ? null : { whitespace: true };
  }

  // Price Formatting
 formatCurrency(value: string | number): string {
  if (value === null || value === undefined || value === '') return '';
  const num = Number(String(value).replace(/,/g, ''));
  return isNaN(num) ? '' : new Intl.NumberFormat('en-IN').format(num);
}

onProductCostInput(event: Event): void {
  const input = event.target as HTMLInputElement;

  const plainValue = input.value.replace(/,/g, '');

  if (!plainValue || isNaN(Number(plainValue))) {
    this.newInventoryForm.get('maximumCost')?.setValue(plainValue, { emitEvent: false });
    return;
  }

  const formatted = this.formatCurrency(plainValue);
  this.newInventoryForm.get('maximumCost')?.setValue(plainValue, { emitEvent: false });
  input.value = formatted;
}

  blockNonNumeric(event: KeyboardEvent): void {
    const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Tab"];
    if (!/[0-9]/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  submitted = false;
  userDepartment: string | null = null;
  showForwardButton = false;
  today: string;
  showForwardFilter = false;
  loggedUserId: any;
  ngOnInit() {
    this.getAllUsers();
    this.getNewInventory();
    this.getApproverUsersList();
    this.loggedUserId = localStorage.getItem("guestID");
    this.userDepartment = localStorage.getItem("department");
    this.showForwardButton = isHrOrItAdminDept(this.userDepartment);
    this.showForwardFilter =
      isHrOrItAdminDept(this.userDepartment) || this.userDepartment === "ADMIN";
    const now = new Date();
    this.today = now.toISOString().split("T")[0];

    this.route.queryParams.subscribe((params) => {
      const filter = params["filter"];
      if (filter) {
        this.selectedFilter = filter;
        this.applyFilterFromQuery(filter);
        setTimeout(() => this.selectedFilter = filter, 0);

      }
    });
  }

applyFilterFromQuery(displayFilter: string) {
  const filterValue = this.filterTypeMap[displayFilter];

  this.selectedFilter = filterValue;  

  switch (displayFilter) {
    case "New Inventory Request":
      this.getNewInventory();
      break;
    case "Pending Request":
      this.onFilterPendingRequest(filterValue);
      break;
    case "Approved Request":
        this.getApprovedNewInventory();
      break;
    case "Declined Request":
    case "Rejected":
      this.onFilterDeclinedRequest(filterValue);
      break;
    case "Forwarded Request":
      this.onRequestSelect(filterValue);
      break;
    default:
      console.warn("Unknown filter:", displayFilter);
  }
}


  filterTypeMap: Record<string, string> = {
    "Approved Request": "New Inventory Request",
    "Pending Request": "New Inventory Request",
    "Forwarded Request": "New Inventory Request",
    "Declined Request": "Rejected",
    Rejected: "Rejected",
  };

  // Reset Form
  openNewRequest() {
    this.newInventoryForm.reset();
    this.formSubmitted = false;
    this.submitted = false;
  }

  pendingReq = [];
  totalPending: any;
  currentRequestType: string = "";

  currentPageNum: number = 1;
  loading = false;
  hasMoreData = true;
  currentPendingLimit = 1000;
onFilterPendingRequest(
  requestType: string,
  pageNum: number = 1,   // always reset to 1 when switching
  limit: number = this.currentPendingLimit
) {
  // If switching to a new request type (or forcing refresh), reset everything
  if (requestType !== this.currentRequestType) {
    this.currentRequestType = requestType;
    this.selectedRequestType = requestType;
    this.pendingReq = [];
    this.currentPageNum = 1;
    this.hasMoreData = true;   // reset so it fetches fresh data
  }

  // Don't block refresh on hasMoreData when switching tabs
  if (this.loading) return;

  this.loading = true;

  const getPendingReqValue: any = {
    requestType: this.currentRequestType,
    pageNum: this.currentPageNum,
    limit: limit,
  };

  console.log("Sending pagination:", getPendingReqValue);

  this.inventoryService.getPendingRequest(getPendingReqValue)
    .subscribe((response) => {
      const records = response["data"].records || [];
      const total = response["data"].totalCounts || 0;

      if (this.currentPageNum === 1) {
        this.pendingReq = records;
      } else {
        this.pendingReq = [...this.pendingReq, ...records];
      }

      this.totalPending = total;
      this.loading = false;

      if (this.pendingReq.length < total) {
        this.currentPageNum++;
        this.hasMoreData = true;
      } else {
        this.hasMoreData = false;
      }

      // Show only pending request table
      this.showForwardedReqTable = false;
      this.showServiceRequestTable = false;
      this.showApprovedRequest = false;
      this.showPendingRequest = true;
      this.showDeclinedRequest = false;
    });
}



  pendingSearchQuery: any;
  searchedPendingInventory = [];
  totalPendingSearchedInv: any;
  onSearchPendingInventory() {
    const getPendingReqValue: any = {
      requestType: "New Inventory Request",
      searchQuery: this.pendingSearchQuery,
      pageNum: this.currentPageNume,
      limit: this.totalPending,
    };

    if (!this.pendingSearchQuery || this.pendingSearchQuery.trim() === "") {
      this.clearPendingSearch();
    } else {
      this.inventoryService
        .getPendingRequest(getPendingReqValue)
        .subscribe((response) => {
          console.log("Search Pending Response", response);
          this.searchedPendingInventory = response["data"].records;
          this.pendingReq = this.searchedPendingInventory;
          this.totalPendingSearchedInv = response["data"].totalCounts;
          this.totalPending = this.totalPendingSearchedInv;
        });
    }
  }

  clearPendingSearch() {
    this.pendingSearchQuery = "";
    this.onFilterPendingRequest(
      "New Inventory Request",
      1,
      this.currentPendingLimit
    );
  }

  totalApprovedSearchedInv: any;
  searchedApprovedInventory = [];
  approvedSearchQuery: any;
  onSearchApprovedInventory() {
    const getApprovedReqValue: any = {
      requestType: "New Inventory Request",
      pageNum: this.currentPageNume,
      limit: this.totalApprNewInventory,
      status: 'Approved',
      searchQuery: this.approvedSearchQuery,

    };
    if(this.showForwardButton) {
      getApprovedReqValue.isAll = true;
    }

    if (!this.approvedSearchQuery || this.approvedSearchQuery.trim() === "") {
      this.clearApprovedSearch();
    } else {
      this.inventoryService
        .getNewInventoryRequest(getApprovedReqValue)
        .subscribe((response) => {
          console.log("Search Approved Response", response);
          this.searchedApprovedInventory = response["data"].records;
          this.newApprInventories = this.searchedApprovedInventory;
          this.totalApprovedSearchedInv = response["data"].totalCounts;
          this.totalApprNewInventory = this.totalApprovedSearchedInv;
        });
    }
  }

  clearApprovedSearch() {
    this.approvedSearchQuery = "";
   this.getApprovedNewInventory();
  }


  declineInv = [];
  totalDeclined: any;
  currentDeclinedLimit = 100;
  onFilterDeclinedRequest(
    status: string = "Rejected",
    pageNum = this.currentPageNume,
    limit = this.currentDeclinedLimit
  ) {
    const field: any = {
      pageNum: 1,
      limit: limit,
      status: status,
    };
    this.inventoryService
      .getNewInventoryRequest(field)
      .subscribe((response) => {
        console.log("Approved Request", response);
        // this.declineInv = response["data"].records;
        if (pageNum === 1) {
          this.declineInv = response["data"].records;
        } else {
          this.declineInv = [...this.declineInv, ...response["data"].records];
        }
        this.totalDeclined = response["data"].totalCounts;
        this.showApprovedRequest = false;
        this.showServiceRequestTable = false;
        this.showPendingRequest = false;
        this.showDeclinedRequest = true;
        this.showForwardedReqTable = false;
      });
  }

  declinedSearchQuery: any;
  searchedDeclinedInventory = [];
  totalDeclinedSearchedInv: any;
  onSearchDeclinedInventory() {
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.totalDeclined,
      searchQuery: this.declinedSearchQuery,
      status: "Rejected",
    };

    if (!this.declinedSearchQuery || this.declinedSearchQuery.trim() === "") {
      this.clearDeclinedSearch();
    } else {
      this.inventoryService
        .getNewInventoryRequest(field)
        .subscribe((response) => {
          console.log("Search Declined Response", response);
          this.searchedDeclinedInventory = response["data"].records;
          this.declineInv = this.searchedDeclinedInventory;
          this.totalDeclinedSearchedInv = response["data"].totalCounts;
          this.totalDeclined = this.totalDeclinedSearchedInv;
        });
    }
  }

  clearDeclinedSearch() {
    this.declinedSearchQuery = "";
    this.onFilterDeclinedRequest("Rejected", 1, this.currentDeclinedLimit);
  }
  showForwardedReqTable: boolean = false;
  showServiceRequestTable: boolean = true;
  showApprovedRequest: boolean = false;
  showPendingRequest: boolean = false;
  showDeclinedRequest: boolean = false;
  onRequestSelect(value: string): void {
    this.selectedRequestType = value;
    console.log("Selected value:", value);
    this.showForwardedReqTable = true;
    this.showServiceRequestTable = false;
    this.showApprovedRequest = false;
    this.showPendingRequest = false;
    this.showDeclinedRequest = false;

    this.filterForwardReq(value);
  }

  forwardedReq = [];
  totalForwarded: any;
  currentForwardLimit = 1000;
  filterForwardReq(
    requestType: string,
    pageNum = this.currentPageNume,
    limit = this.currentForwardLimit
  ) {
    this.currentRequestType = requestType;
    const getForwardReqValue: any = {
      requestType: requestType,
      pageNum: this.currentPageNume,
      limit: this.currentForwardLimit,
    };

    this.inventoryService
      .getAllForwardedReq(getForwardReqValue)
      .subscribe((response) => {
        console.log("Forward Response", response);
        // this.forwardedReq = response['data'].records;
        if (pageNum === 1) {
          this.forwardedReq = response["data"].records;
        } else {
          this.forwardedReq = [
            ...this.forwardedReq,
            ...response["data"].records,
          ];
        }
        this.totalForwarded = response["data"].totalCounts;
        this.showForwardedReqTable = true;
        this.showServiceRequestTable = false;
        this.showApprovedRequest = false;
        this.showPendingRequest = false;
        this.showDeclinedRequest = false;
        // this.getNewInventory();
      });
  }

  forwardedSearchQuery: any;
  searchedForwardedInventory = [];
  totalForwardedSearchedInv: any;
  onSearchForwardedInventory() {
    const getForwardReqValue: any = {
      requestType: this.currentRequestType || "New Inventory Request",
      searchQuery: this.forwardedSearchQuery,
      pageNum: this.currentPageNume,
      limit: this.totalForwarded,
    };

    if (!this.forwardedSearchQuery || this.forwardedSearchQuery.trim() === "") {
      this.clearForwardedSearch();
    } else {
      this.inventoryService
        .getAllForwardedReq(getForwardReqValue)
        .subscribe((response) => {
          console.log("Searched Forwarded Response", response);
          this.searchedForwardedInventory = response["data"].records;
          this.forwardedReq = this.searchedForwardedInventory;
          this.totalForwardedSearchedInv = response["data"].totalCounts;
          this.totalForwarded = this.totalForwardedSearchedInv;
        });
    }
  }

  clearForwardedSearch() {
    this.forwardedSearchQuery = "";
    this.filterForwardReq(
      this.currentRequestType || "New Inventory Request",
      1,
      this.currentLimit
    );
  }

  // Approver Users (ADMIN, IT-ADMIN, HR-HEAD, HR)
  approverUsers: { value: string; viewValue: string; id: string; department?: string }[] = [];
  adminUsers: { value: string; viewValue: string; id: string }[] = [];
  hrUsers: { value: string; viewValue: string; id: string }[] = [];

  getApproverUsersList(): void {
    const approverDepts = INVENTORY_APPROVER_DEPARTMENTS;
    forkJoin(
      approverDepts.map((dept) =>
        this.crmService.getAnyUsers(dept).pipe(
          catchError((err) => {
            console.error(`Error fetching approvers for department ${dept}:`, err);
            return of({ data: [] });
          })
        )
      )
    ).subscribe((results: any[]) => {
      const userMap = new Map<string, { value: string; viewValue: string; id: string; department?: string }>();

      results.forEach((res, index) => {
        const expectedDept = approverDepts[index];
        const rawList = res?.data || res?.records || (Array.isArray(res) ? res : []);
        if (Array.isArray(rawList)) {
          rawList.forEach((user: any) => {
            const id = user?._id || user?.id;
            const userName = (user?.userName || user?.name || '').trim();
            const userDept = user?.department ? String(user.department).trim().toUpperCase() : expectedDept;
            if (id && userName && approverDepts.includes(userDept)) {
              if (!userMap.has(id)) {
                userMap.set(id, {
                  value: userName,
                  viewValue: userName,
                  id: id,
                  department: userDept,
                });
              }
            }
          });
        }
      });

      const sortedUsers = Array.from(userMap.values()).sort((a, b) =>
        a.viewValue.localeCompare(b.viewValue, undefined, { sensitivity: 'base' })
      );

      this.approverUsers = sortedUsers;
      this.adminUsers = sortedUsers;
      this.hrUsers = sortedUsers;
      console.log("Filtered approvers:", this.approverUsers);
    });
  }

  getAdminUsersList() {
    this.getApproverUsersList();
  }

  getHRUsersList() {
    this.getApproverUsersList();
  }

  getAllUsers(): void {
    this.inventoryService.getInvUsers().subscribe((res) => {
      let data = res["data"];
      this.users = data.map((user: any) => ({
        value: user.userName,
        viewValue: user.userName,
        id: user._id,
      }));
      console.log("users", this.users);
    });
  }

  // Shimmer Loader
  isShimmerLoading: boolean = true;
  shimmerLoadingValue = ([] = [1, 2, 3, 4, 5]);

  //Formatted Start DATE
  formatStartDate(date: Date): { day: number; month: number; year: number } {
    return {
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear(),
    };
  }
  formSubmitted = false;
  isSubmitting: boolean = false;
 onSubmitForm() {
  console.log(this.newInventoryForm.value);
  this.submitted = true;

  if (this.newInventoryForm.invalid) {
    console.log("Form is invalid");
    return alertModalWithoutConfirm(
      "warning",
      "Please fill in all required fields before submitting."
    );
  }

  if (this.isSubmitting) {
    return;
  }
  this.isSubmitting = true;

  const newInventoryValues = { ...this.newInventoryForm.value };

  const startDate = new Date(newInventoryValues.startDate);
  const formattedStartDate = this.formatStartDate(startDate);

 const endDate = new Date(newInventoryValues.endDate);
  const formattedEndDate = this.formatStartDate(endDate);


  const approver = (this.approverUsers && this.approverUsers.length > 0 ? this.approverUsers : [...this.adminUsers, ...this.hrUsers]).find(
    (user) => user.value === newInventoryValues.approverName
  );
  console.log("approver:", approver);
  const approverId = approver ? approver.id : null;
  console.log({ approverId });

  const linksArray = [
    newInventoryValues.link1,
    newInventoryValues.link2,
    newInventoryValues.link3,
  ].filter((link) => link);

  const getNewInventoryFormValue: any = {
    assetCategory: String(newInventoryValues.assetCategory),
    projectName: String(newInventoryValues.projectName),
    startDate: {
      day: startDate.getDate(),
      month: startDate.getMonth() + 1,
      year: startDate.getFullYear(),
    },
      endDate: {
      day: endDate.getDate(),
      month: endDate.getMonth() + 1,
      year: endDate.getFullYear(),
    },
    links: linksArray,
    urgency: newInventoryValues.urgency,
    approverName: String(newInventoryValues.approverName || ""),
    redirectUrl:`${environment.redirectUrl}#/inventory/new-inventory-request`,
  };

  if (this.showForwardButton) {
    getNewInventoryFormValue.redirectUrl = `${environment.redirectUrl}#/inventory/admin-request?filter=New Inventory Request`;
  }

  getNewInventoryFormValue.maximumCost = String(
    newInventoryValues.maximumCost || "0"
  );
  getNewInventoryFormValue.comment = String(
    newInventoryValues.comment || ""
  );

  if (!this.showForwardButton) {
    // Non-HR users → approver required
    if (!approverId) {
      alertModalWithoutConfirm("warning", "Please select an approver.");
      this.isSubmitting = false;
      return;
    }
    getNewInventoryFormValue.approverId = approverId;
  } else {
    // HR users → approver optional
    if (approverId) {
      getNewInventoryFormValue.approverId = approverId;
    }
  }

  this.inventoryService.newInventoryRequest(getNewInventoryFormValue).subscribe(
    (response) => {
      console.log("submitted ", response);
      this.currentPageNume = 1;
      this.newInventories = [];
      this.formSubmitted = true;
      this.isSubmitting = false;
      this.showForwardedReqTable = false;
      this.showServiceRequestTable = true;
      this.getNewInventory();
    },
    (error) => {
      console.log("Error", error);
      this.isSubmitting = false;
    }
  );
}

  currentPageNume = 1;
  currentLimit = 100;
  selectedRequestType: any;
  onScroll() {
    if (this.showServiceRequestTable) {
      console.log(
        "Scrolled! Current service Request Length:",
        this.newInventories.length
      );
      const totalLoaded = this.newInventories.length;
      if (totalLoaded >= this.totalNewInventory) return;
      this.currentPageNume++;
      this.getNewInventory();
    }

    if (this.showPendingRequest) {
      const totalLoaded = this.pendingReq.length;
      if (totalLoaded >= this.totalPending) return;
      this.currentPageNume++;
      this.onFilterPendingRequest(
        this.selectedRequestType,
        this.currentPageNum,
        this.currentPendingLimit
      );
    }

    if (this.showApprovedRequest) {
      const totalLoaded = this.newApprInventories.length;
      if (totalLoaded >= this.totalApprNewInventory) return;
      this.currentPageNume++;
     this.getApprovedNewInventory();
    }

    if (this.showDeclinedRequest) {
      const totalLoaded = this.declineInv.length;
      if (totalLoaded >= this.totalDeclined) return;
      this.currentPageNume++;
      this.onFilterDeclinedRequest(
        this.selectedRequestType,
        this.currentPageNume,
        this.currentDeclinedLimit
      );
    }

    if (this.showForwardedReqTable) {
      const totalLoaded = this.forwardedReq.length;
      if (totalLoaded >= this.totalForwarded) return;
      this.currentPageNume++;
      this.filterForwardReq(
        this.selectedRequestType,
        this.currentPageNume,
        this.currentForwardLimit
      );
    }
  }

  selectedInventory: any = {};
  newInvReqId: any = {};
  newInventories = [];
  totalNewInventory: any;
  searchQuery: string;
  showActionHeader = false;
getNewInventory(pageNum: number = this.currentPageNume, limit: number = this.currentLimit) {
  this.pendingReq = [];
  this.currentPageNum = 1;
  this.hasMoreData = true;

  if (pageNum === 1) {
    this.newInventories = [];
  }

  const field: any = {
    pageNum: pageNum,
    limit: limit,
    searchQuery: this.searchQuery,
  };

  this.inventoryService.getNewInventoryRequest(field).subscribe((response) => {
    const records = response["data"].records || [];
    this.newInventories = [...this.newInventories, ...records];
    this.totalNewInventory = response["data"].totalCounts;

    this.showActionHeader = this.newInventories.some(req => req.requestedById === this.loggedUserId);

    this.showForwardedReqTable = false;
    this.showServiceRequestTable = true;
    this.showDeclinedRequest = false;
    this.showPendingRequest = false;
    this.isShimmerLoading = false;

    if (this.newInventories.length < this.totalNewInventory) {
      this.currentPageNume++;
    }
  });
}

  searchNewInventoryQuery: any;
  searchedInventory = [];
  totalSearchedInv: any;
  onSearchNewInventory() {
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.totalNewInventory,
      searchQuery: this.searchNewInventoryQuery,
    };
    if (this.searchNewInventoryQuery === "") {
      this.clearSearch();
    } else {
      this.inventoryService
        .getNewInventoryRequest(field)
        .subscribe((response) => {
          console.log(response);
          this.searchedInventory = response["data"].records;
          this.newInventories = this.searchedInventory;
          this.totalSearchedInv = response["data"].totalCounts;
          this.totalNewInventory = this.totalSearchedInv;
        });
    }
  }

  clearSearch() {
    this.searchNewInventoryQuery = "";
    this.newInventories = [];
    this.getNewInventory();
  }
  onRequestForwarded(forwardedRequestId: string) {
    this.newInventories = this.newInventories.filter(
      (req) => req.requestId !== forwardedRequestId
    );
    this.totalNewInventory = this.newInventories.length;
  }

  disableTyping(event: KeyboardEvent) {
    event.preventDefault();
  }

  newApprInventories = [];
  totalApprNewInventory: any;
  getApprovedNewInventory() {
    const field: any = {
      pageNum: 1,
      limit: 100,
      status: "Approved",
    };
    this.inventoryService
      .getNewInventoryRequest(field)
      .subscribe((response) => {
        console.log("Response", response);
        this.showApprovedRequest = true;
        this.newApprInventories = response["data"].records;
        this.totalApprNewInventory = response["data"].totalCounts;
        // this.showApprovedRequest = false;
        this.showPendingRequest = false;
        this.showForwardedReqTable = false;
        this.showServiceRequestTable = false;
        this.showDeclinedRequest = false;
      });
  }

  openForward(requestId: any) {
    console.log("Request ID", requestId);
    // this.selectedInventory = null;
    this.newInvReqId = requestId;
    const forwardReqComponent = this.forwardReqComponentRef;
    if (forwardReqComponent) {
      forwardReqComponent.forwardReqReset();
    }
  }
  acceptRequest(requestId: any) {
    const acceptRequest = {
      action: "Accept",
      requestId: requestId,
      requestType: "New Inventory Request",
      redirectUrl:`${environment.redirectUrl}#/inventory/new-inventory-request?filter=Approved Request`,
    };
    this.inventoryService.adminAction(acceptRequest).subscribe((response) => {
      console.log("called");
      alertModalWithoutConfirm("success", "Request Approved")
      // this.snackBar.open("Accepted", "OK");
      window.location.reload();

      this.getNewInventory();
    });
  }

  async declineRequest(requestId: any) {
    const userConfirmed = await alertModalDecline(
      "Are you sure you want to decline this request?"
    );
    if (userConfirmed) {
      const declineRequest = {
        action: "Rejected",
        requestId: requestId,
        requestType: "New Inventory Request",
        redirectUrl:`${environment.redirectUrl}#/inventory/new-inventory-request?filter=Declined Request`,
      };
      this.inventoryService.adminAction(declineRequest).subscribe(
        (response) => {
           window.location.reload();
          this.getNewInventory();
        },
        (err) => {
          console.error("Error while declining the request", err);
          alertModalWithoutConfirm("error", "Failed to decline the request.");
        }
      );
    } else {
      console.log("User cancelled the decline action");
    }
  }

  async deletenewInventoryRequest(requestId: any, approverId: any) {
    const userConfirmed = await alertModalDelete(
      "Are you sure you want to delete this request?"
    );
    if (userConfirmed) {
      const declineRequest = {
        approverId: approverId,
        requestId: requestId,
        requestType: "New Inventory Request",
      };

      this.inventoryService.deleteAction(declineRequest).subscribe(
        (response) => {
          // this.snackBar.open("Request Declined", "OK");
          this.getNewInventory();
        },
        (err) => {
          alertModalWithoutConfirm("error", "Failed to delete the request.");
        }
      );
    }
  }
}
